import { TxpOptionState } from '../store/schema/TxpOptionState';
import getStore from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
import { TxpEventFlags } from '../utils/getTxpFlagInfo';
export interface UpdateTxpFlagState {
    optionState: TxpOptionState;
}

/**
 * The type encapsulating all the flags that can be set on the TxpOptionState
 */
type TxpStateFlags = 'EventsFromEmailEnabled' | 'CreateEventsFromEmailAsPrivate';

/**
 * The action to update the flags behind the checkboxes in the txp options UI
 */
export default select<UpdateTxpFlagState>({
    optionState: () => getStore(),
})(
    action('updateTxpFlag')(function updateTxpFlag(
        flagName: TxpStateFlags | TxpEventFlags,
        enabled: boolean,
        state?: UpdateTxpFlagState
    ) {
        let { optionState } = state;
        if (flagName == 'EventsFromEmailEnabled' || flagName == 'CreateEventsFromEmailAsPrivate') {
            optionState[flagName] = enabled;
        } else if (flagName) {
            optionState.Events[flagName] = enabled;
        }
    })
);
